/*** IMPORTS FROM imports-loader ***/
var define = false;

require("datejs");

require("./DateExtensions");

module.exports = Date;




//////////////////
// WEBPACK FOOTER
// ./~/pli/date/index.js
// module id = 423
// module chunks = 49